import React from "react";
import "./Navbar.css";
import { Link } from "react-scroll";
import Moon from "@iconscout/react-unicons/icons/uil-moon";
import Sun from "@iconscout/react-unicons/icons/uil-sun";

const navbar = ({ theme, onToggleTheme }) => {
  return (
    <header className="n-wrapper" id="Navbar">
      <div className="n-left">
        <Link to="Intro" spy={true} smooth={true} className="n-brand">
          <span>Sicelo</span>
          <small>Full-stack Developer</small>
        </Link>
      </div>
      <nav className="n-right" aria-label="Primary navigation">
        <div className="n-list">
          <ul>
            <li>
              <Link activeClass="active" to="Intro" spy={true} smooth={true}>
                Home
              </Link>
            </li>
            <li>
              <Link to="services" spy={true} smooth={true}>
                Services
              </Link>
            </li>
            <li>
              <Link to="experience" spy={true} smooth={true}>
                Experience
              </Link>
            </li>
            <li>
              <Link to="portfolio" spy={true} smooth={true}>
                Portfolio
              </Link>
            </li>
          </ul>
        </div>
        <button
          className="theme-toggle"
          type="button"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        >
          {theme === "dark" ? <Sun size="1.15rem" /> : <Moon size="1.15rem" />}
        </button>
        <Link to="contact" spy={true} smooth={true}>
          <button className="button n-button">Contact</button>
        </Link>
      </nav>
    </header>
  );
};

export default navbar;
